import { sleep } from "#/frontend-utils/utils/common";

export async function sliceTask(i: number, chunkSize: number, sleepTime: number): Promise<void> {
  if (i % chunkSize === 0) await sleep(sleepTime);
}
